import { Outlet } from 'react-router';

import { ClaimHeader } from '@/components/layout/claim/header';
import { LayoutContainer } from '@/components/layout/container';
import { CookieContainer } from '@/components/layout/cookie-container';
import { blokkieTheme } from '@tikkie/blokkie';

interface Props {
  backgroundColor?: string;
}

export function ClaimLayout({ backgroundColor }: Props) {
  return (
    <CookieContainer>
      <LayoutContainer backgroundColor={backgroundColor}>
        <ClaimHeader />

        <main
          style={{
            paddingInline: blokkieTheme.spacing(2),
          }}
        >
          <Outlet />
        </main>
      </LayoutContainer>
    </CookieContainer>
  );
}
